// extracted by mini-css-extract-plugin
module.exports = {"cabecalho":"FiltroDataCabecalho_cabecalho__QZUsw"};